import React from 'react';
import RentRoll from '../SummaryPage/RentRoll';
import { Helmet } from 'react-helmet';
import { PAGES } from '../../schemas/stepMap';
import PropertyPageHeader from '../../components/PropertyPageHeader';

export default function RentRollPage() {
  const rentRollPage = PAGES.rentRoll;
  return (
    <div>
      <Helmet>
        <title>PropertyCast.io - Rent Roll</title>
      </Helmet>
      <section className="">
        <PropertyPageHeader
          title={rentRollPage.name}
          description={rentRollPage.description}
        />

        <RentRoll />
      </section>
    </div>
  );
}
